"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskViewFields = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const StaticFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/StaticFieldType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const ViewFieldKey_1 = __importDefault(require("../ViewFieldKey"));
exports.TaskViewFields = {
    [ViewFieldKey_1.default.TASK_STARTED]: {
        key: ViewFieldKey_1.default.TASK_STARTED,
        label: () => lib_i18n_1.default.t('task-started'),
        description: () => lib_i18n_1.default.t('task-started-description'),
        sortable: false,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'startedDate',
        width: 150,
        gqlFields: 'startedDate',
    },
    [ViewFieldKey_1.default.TASK_COMPLETED]: {
        key: ViewFieldKey_1.default.TASK_COMPLETED,
        label: () => lib_i18n_1.default.t('task-completed'),
        description: () => lib_i18n_1.default.t('task-completed-description'),
        sortable: false,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'completedDate',
        width: 150,
        gqlFields: 'completedDate',
    },
    [ViewFieldKey_1.default.TASK_TYPE]: {
        key: ViewFieldKey_1.default.TASK_TYPE,
        label: () => lib_i18n_1.default.t('task-type'),
        description: () => lib_i18n_1.default.t('task-type-description'),
        sortable: true,
        fieldType: StaticFieldType_1.default.TASK_TYPE,
        propertyName: 'type',
        width: 150,
        gqlFields: 'type',
    },
    [ViewFieldKey_1.default.TASK_STATUS]: {
        key: ViewFieldKey_1.default.TASK_STATUS,
        label: () => lib_i18n_1.default.t('task-status'),
        description: () => lib_i18n_1.default.t('task-status-description'),
        sortable: true,
        fieldType: StaticFieldType_1.default.TASK_STATUS,
        propertyName: 'fullStatus',
        width: 150,
        gqlFields: 'status',
    },
    [ViewFieldKey_1.default.TASK_DURATION]: {
        key: ViewFieldKey_1.default.TASK_DURATION,
        label: () => lib_i18n_1.default.t('task-duration'),
        description: () => lib_i18n_1.default.t('task-duration-description'),
        sortable: false,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'duration',
        width: 150,
        gqlFields: 'startedDate, completedDate',
    },
};
exports.default = exports.TaskViewFields;
